(function () {
  function normalize(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function filterCards(section) {
    var input = section.querySelector('[data-help-search-input]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-help-search-item]'));
    var empty = section.querySelector('[data-help-search-empty]');
    var query = normalize(input ? input.value : '');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var isVisible = !query || normalize(card.textContent).indexOf(query) !== -1;
      card.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (empty) {
      empty.hidden = visibleCount > 0;
    }
  }

  function initSection(section) {
    if (!section || section.dataset.helpSearchCardsReady === 'true') {
      return;
    }

    section.dataset.helpSearchCardsReady = 'true';

    var input = section.querySelector('[data-help-search-input]');
    var button = section.querySelector('[data-help-search-submit]');

    if (input) {
      input.addEventListener('input', function () {
        filterCards(section);
      });
    }

    if (button) {
      button.addEventListener('click', function () {
        filterCards(section);

        if (input) {
          input.focus();
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-help-search-cards]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
